import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Colors, AnalyticsProps } from '@inplayer-org/inplayer-ui';
import { transparentize } from 'polished';

// components
import { PreviewBox, Image, Title, Button, Description } from './StyledElements';

const StyledButton = styled(Button)`
  margin: 0 auto;
  border: 3px solid ${transparentize(0.9, Colors.black)};
  top: 35%;
  left: 35%;
  width: 30%;
  box-sizing: border-box;
  height: 15px;
  position: absolute;

  ${PreviewBox}:hover & {
    background: ${transparentize(0.3, Colors.red)};
    border: 3px solid ${transparentize(0.9, Colors.black)};
  }
`;

interface OwnProps extends AnalyticsProps {
  id: number;
  onBodyClick: (id: number) => void;
  isTemplateSelected: boolean;
}

const PreviewTemplate5: FunctionComponent<OwnProps> = ({ id, onBodyClick, isTemplateSelected }) => {
  const onClick = () => onBodyClick(id);

  return (
    <PreviewBox onClick={onClick} isTemplateSelected={isTemplateSelected}>
      <Image isTemplateSelected={isTemplateSelected}>
        <StyledButton isTemplateSelected={isTemplateSelected} />
      </Image>
      <Title />
      <Description />
      <Description />
      <Description />
    </PreviewBox>
  );
};

export default PreviewTemplate5;
